import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState(600);
  useEffect(() => {
    const storedEndTime = localStorage.getItem('nochesDePaz_timerEnd');
    const now = new Date().getTime();
    if (storedEndTime) {
      const remaining = Math.floor((parseInt(storedEndTime) - now) / 1000);
      if (remaining > 0) {
        setTimeLeft(remaining);
      } else {
        const newEndTime = now + 600 * 1000;
        localStorage.setItem('nochesDePaz_timerEnd', newEndTime.toString());
        setTimeLeft(600);
      }
    } else {
      const newEndTime = now + 600 * 1000;
      localStorage.setItem('nochesDePaz_timerEnd', newEndTime.toString());
    }
    const interval = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          const newEndTime = new Date().getTime() + 600 * 1000;
          localStorage.setItem('nochesDePaz_timerEnd', newEndTime.toString());
          return 600;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <div className="inline-flex items-center gap-2 bg-red-50 text-red-600 font-bold py-2 px-4 rounded-lg border border-red-200" data-id="element-67">
      <Clock className="w-4 h-4" data-id="element-68" />
      <span className="text-lg tracking-wider" data-id="element-69">
        {minutes.toString().padStart(2, '0')}:
        {seconds.toString().padStart(2, '0')}
      </span>
    </div>;
}